export default {
  list() {
    return axios.get('/dashboard/mobile-hero-settings')
  },

  create(payload) {
    return axios.post('/dashboard/mobile-hero-settings', payload)
  },

  get(id) {
    return axios.get(`/dashboard/mobile-hero-settings/${id}`)
  },

  update(payload) {
    return axios.put(`/dashboard/mobile-hero-settings/${payload.id}`, payload)
  },

  copy(id, payload) {
    return axios.post(`/dashboard/mobile-hero-settings/${id}/copy`, payload)
  },

  delete(id) {
    return axios.delete(`/dashboard/mobile-hero-settings/${id}`)
  }
}
